import { Component } from 'react'
import { withIdleTimer } from 'react-idle-timer'
import { authContext } from "./context/AuthContext";

class IdleTimerComponent extends Component {
	              static contextType = authContext;
	onLogout () {
    // Do something when a user triggers a watched event
        console.log("IdleTimer onLogout")
        console.log(this.context);
  }

  render () {
    return (
        <>{this.props.children}</>
    )
  }
}

export const IdleTimer = withIdleTimer(IdleTimerComponent)